import gql from 'graphql-tag';
import FieldsBookingInvitation from "graphql/fields/FieldsBookingInvitation";
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'booking_date': 'String',
	'active': '[String]',
}

export default gql(`
	query employee_booking_invitations_sent( ${ HelperGraphql.createFields( fields ) } ) {
		employee_booking_invitations_sent( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsBookingInvitation}
			
			employee {
				guid
				name
			}
			
			employees_invited {
				dates
				responded
				accepted
				rejected
				
				employee {
					guid
					name
				}
			}
			
			bookings {
				kind
			}
		}
	}
`);

